const link =
  "font-medium text-neutral-900 underline decoration-neutral-300 underline-offset-2 hover:decoration-neutral-900"

const CALENDLY_URL = "https://calendly.com/nathan-mccarley-landsentry/30min"
const SUPPORT_EMAIL = "support@landsentry.com"

export default function SupportPage() {
  return (
    <div className="min-h-[60vh] bg-white px-6 py-10 pb-20">
      <div className="mx-auto max-w-3xl text-sm leading-relaxed text-neutral-700">
        <h1 className="border-b border-neutral-200 pb-3 text-2xl font-semibold tracking-tight text-neutral-900">
          Support
        </h1>

        <p className="mt-10">
          LandSentry is currently in private beta. If you need help or have questions, reach out directly.
        </p>

        <ul className="mt-8 list-disc space-y-3 pl-5">
          <li>
            <strong className="text-neutral-900">Email:</strong>{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} className={link}>
              {SUPPORT_EMAIL}
            </a>
          </li>
          <li>
            <strong className="text-neutral-900">Schedule a call:</strong>{" "}
            <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className={link}>
              Book a call on Calendly
            </a>
          </li>
        </ul>

        <p className="mt-10 text-neutral-500">We typically respond within 24 hours.</p>
      </div>
    </div>
  )
}
